import { createFileRoute, useParams } from "@tanstack/react-router";

import { DraftAttributeRendererWrapper } from "../-components";
import {
  SectionFormWrapper,
  prefetchDraftCatalog,
  useSaveDraftCatalog,
  useDraftCatalogFormStore,
  useGetDeviceCatalogFormItems,
  type SectionGroup,
} from "../-shared";
import { SectionGroupContent as SharedSectionGroupContent } from "../../../../-components/shared";

export const Route = createFileRoute(
  "/_staff/device-catalog/draft/$id/_layout/profile/",
)({
  component: DraftProfile,
  loader: prefetchDraftCatalog,
});

function DraftProfile() {
  const { id } = useParams({
    from: "/_staff/device-catalog/draft/$id/_layout/profile/",
  });

  return (
    <SectionFormWrapper
      useSaveMutation={(options) => useSaveDraftCatalog(id, options)}
      groupBySectionKey={true}
      renderContent={(props) => {
        if ("sectionGroup" in props) {
          return (
            <ProfileContent
              sectionGroup={props.sectionGroup}
              isEditing={props.isEditing}
            />
          );
        }
        return null;
      }}
    />
  );
}

/**
 * Provider内でフックを呼び出すための内部コンポーネント
 */
function ProfileContent({
  sectionGroup,
  isEditing,
}: {
  sectionGroup: SectionGroup;
  isEditing?: boolean;
}) {
  // Provider内でフックを呼び出す
  const { actions } = useDraftCatalogFormStore();
  const { data: formItems } = useGetDeviceCatalogFormItems();

  return (
    <SharedSectionGroupContent
      sectionGroup={sectionGroup}
      readonly={false}
      isEditing={isEditing}
      onRemoveSection={(sectionKey, displayOrder) =>
        actions.removeSection(sectionKey, displayOrder)
      }
      renderAttributes={(section) => (
        <DraftAttributeRendererWrapper
          attributes={section.attributes}
          sectionKey={String(section.sectionKey)}
          displayOrder={section.displayOrder}
          formItems={formItems}
        />
      )}
    />
  );
}
